export default function getApiVersion() {
  return `v4`
}
